import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthShell, Field, FormError } from "./AuthShell";
import { useAuth } from "../../lib/auth";
import { formatApiError } from "../../lib/api";

const FIELDS = [
  ["name", "Your name", "text", "name"],
  ["organisation", "Organisation / department", "text", "organization"],
  ["phone", "Phone", "tel", "tel"],
  ["email", "Email", "email", "email"],
];

export default function Register() {
  const { user, register } = useAuth();
  const [form, setForm] = useState({ name: "", organisation: "", phone: "", email: "", password: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/account"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setError("Passwords do not match");
    setBusy(true);
    setError("");
    try {
      const { confirm, ...payload } = form;
      await register(payload);
      navigate("/account");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <AuthShell title="Create account" subtitle="Track your work done certificate requests and download our company profile." testid="register-page">
      <title>Create account | Vata Infrastructures</title>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div className="grid gap-4 sm:grid-cols-2">
          {FIELDS.map(([k, label, type, ac]) => (
            <Field key={k} id={`rg-${k}`} label={label} type={type} autoComplete={ac} value={form[k]} onChange={set(k)} data-testid={`register-${k}-input`} />
          ))}
          <Field id="rg-pass" label="Password (min 8)" type="password" minLength={8} autoComplete="new-password" value={form.password} onChange={set("password")} data-testid="register-password-input" />
          <Field id="rg-confirm" label="Confirm password" type="password" minLength={8} autoComplete="new-password" value={form.confirm} onChange={set("confirm")} data-testid="register-confirm-input" />
        </div>
        <FormError error={error} />
        <button type="submit" disabled={busy} data-testid="register-submit" className="btn-rust flex w-full items-center justify-center gap-2 py-4 disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Create account
        </button>
      </form>
      <p className="mt-8 text-sm text-[var(--muted-ink)]">Already have an account? <Link to="/login" data-testid="register-login-link" className="font-semibold text-[var(--ink)] underline">Sign in</Link></p>
    </AuthShell>
  );
}
